<template>
  <div
    class="block dynamic-promo-grid container overflow-auto py-24 xxl:px-24 overflow-hidden"
  >
    <div
      class="-mx-12"
      :class="component.blocks.length !== 3 ? 'md:flex' : 'md:block'"
    >
      <div
        v-for="block in component.blocks"
        :key="block.id"
        class="px-12 w-full mb-24 last:mb-0 sm:mb-32 sm:last:mb-0 lg:mb-0"
        :class="{
          'dynamic-promo-grid__block--3-col': component.blocks.length == 3,
        }"
      >
        <div
          class="content rounded-xl min-h-380 overflow-hidden relative sm:min-h-410 md:min-h-620"
          :style="{ 'background-color': block.color }"
        >
          <nuxt-img
            v-if="block.image && block.background_type == 'image'"
            :src="clearImgUrl(block.image)"
            alt="Blockbild"
            preset="standard"
            sizes="mob375:100vw mob390:100vw mob414:100vw desk:1324px"
            class="absolute top-0 left-0 object-cover object-center h-full w-full rounded-xl"
          />

          <video
            v-if="block.video && block.background_type == 'video'"
            class="absolute top-0 left-0 w-full h-full object-cover rounded-xl"
            autoplay
            muted
            loop
            playsinline
            :poster="block.image"
          >
            <source :src="block.video" type="video/mp4">
          </video>

          <div
            class="absolute bottom-24 sm:bottom-32 md:bottom-40 left-1/2 transform -translate-x-1/2 w-10/12"
          >
            <div
              v-if="block.content"
              class="mb-16 text-xl leading-lg sm:leading-xl sm:text-3xl text-center font-medium"
              v-html="block.content"
            />
            <NuxtLink
              v-if="block.button"
              :to="block.button.url"
              :target="block.button.target"
              class="btn btn--lg w-fit-content mx-auto"
              :class="{
                'btn--primary': block.button_color_theme === 'blue-theme',
                'btn--danger': block.button_color_theme === 'red-theme',
                'btn--secondary btn--ghost':
                  block.button_color_theme === 'transparent-theme',
              }"
            >
              {{ block.button.title }}
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentBlock from '~/models/component-block';

import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    component: {
      type: ComponentBlock,
      required: true,
    },
  },
  methods: {
    clearImgUrl(url:string) {
      const urlPart = url.split('?');
      return urlPart[0];
    },
  },
});
</script>

<style>
.block {
  .dynamic-promo-grid {
    &__block--3-col {
      @screen md {
        @apply w-1/2 float-left;
      }

      &:nth-child(2) {
        @screen md {
          @apply mb-12;
        }
      }

      &:nth-child(3) {
        @screen md {
          @apply mt-12;
        }
      }
      &:nth-child(2),
      &:nth-child(3) {
        .content {
          @screen md {
            min-height: calc(38.75rem / 2 - 0.75rem);
          }
        }
      }
    }
  }
}
</style>
